import config from './config'


export function goPC(to, from, next) {

    if (window.ISPC) {
        //go to pc
        if (window.ISWXMINI || window.ISWX) {
            return
        }

        const name = to.name;
        const id = to.params.id;
        // 需要留在当前 H5 的页面白名单（PC 环境下不跳转）
        const stayOnH5Routes = new Set([
            'Vote',
            'csco',
            'Bms',
            'DocVote',
            'DocPreview',
            'CAXCaseVotePCHomePage',
            'CAXCaseVoteH5HomePage',
            'CAXCaseVoteLogin',
            'CAXCaseVotePCList',
            'CAXCaseVoteH5List',
            'CAXCaseVoteH5Detail',
            'CAXCaseVotePCDetail',
            'DocPreviewNew',
            'LivePreviewNew',
            'EasternCancerCasesHome',
            'gastricRes',
            'NewFeedBack',
            'TnmAiBeiAn',
        ])

        if (stayOnH5Routes.has(name)) {
            return;
        }

        if (self != top) {
            // alert('在iframe里')
            return
        }

        // 跳pc——iframe
        if ( name != 'pcProject' ) {
            let fullUrl =  window.location.href || ''
            let appUrl = encodeURIComponent(fullUrl)
            let newPath =  Global_root_path + '#/pcProject?fullpath=' + appUrl
            next(false)
            location.href = newPath
            return
        }
    } else {
        if (window.ISWXMINI) {
            return
        }
        // go to 手机
        const name = to.name
        if (window.ISMOBILE && !window.ISAPP && name == 'pcProject') {
            let appendArray = window.location.href.split('pcProject?fullpath=')
            if (appendArray.length > 1) {
                let appPath = ''
                if (appendArray[1]) {
                    appPath = decodeURIComponent(appendArray[1])
                }
                next(false)
                location.href = appPath
                return
            }
        }
    }
}
